import styled from 'styled-components';

export const MobileNavWrapper = styled.ul`
	list-style: none;
	padding: 0;
`;
